"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/Controls/ScheduledControl.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Button = require('web/components/Form/Button/Button');
var _MenuItem = require('web/screens/Broadcast/MenuItem'); var _MenuItem2 = _interopRequireDefault(_MenuItem);
var _useMenuButton = require('web/screens/Broadcast/useMenuButton'); var _useMenuButton2 = _interopRequireDefault(_useMenuButton);









/* Rev 27 P2: a scheduled campaign's run control, "Scheduled ▾". Rev 33 T2:
 * its menu has the one Pause…, which unqueues the schedule like Pause on a
 * running campaign; Resume… then sends or schedules again. The menu works
 * like Add more's (useMenuButton). */
const ScheduledControl = ({ isPending = false, onPause }) => {
  // When the server confirms with the menu open, focus moves to Pause.
  const menu = _useMenuButton2.default.call(void 0, { refocusKey: isPending })

  const choose = (action) => () => {
    menu.close(false)
    action()
  }

  return (
    _react2.default.createElement('div', { ref: menu.rootRef, className: "campaign-controls--scheduled", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
      , _react2.default.createElement('button', {
        ...menu.triggerProps,
        type: "button",
        className: _classBuilder2.default.call(void 0, _Button.btnClassName, _Button.secondaryBtnClassName, 'campaign-controls--scheduled-pill'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}

        , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, "schedule"), "Scheduled"

        , _react2.default.createElement('span', { className: "campaign-controls--scheduled-caret", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}, "▾")
      )
      ,  menu.isOpen && (
        _react2.default.createElement('div', {
          ...menu.menuProps,
          'aria-label': "Scheduled send" ,
          className: "broadcast-menu campaign-controls--scheduled-menu" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}

          , _react2.default.createElement(_MenuItem2.default, {
            label: "Pause…",
            iconSrc: "/assets/icons/broadcast/pause-dark.svg",
            disabled: isPending,
            onClick: choose(onPause), __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
          )
        )
      )
    )
  )
}

exports. default = ScheduledControl
